import * as React from 'react';
import { forwardRef } from 'react';
import PhoneInput from 'react-phone-number-input';
import { TextField } from '@mui/material';
import { FieldLabelWithHelp } from './FieldHelpIcon';
import type { E164Number } from 'libphonenumber-js';

type InputPhoneProps = {
  label: string;
  value: string;
  helperText?: string;
  error?: boolean;
  onChange: (value: string) => void;
  autoFocus?: boolean;
  customWidth?: number;
  disabled?: boolean;
  hidden?: boolean;
  description?: string;
  // "(Opcional)" (o el .nullText del campo) junto al label mientras está vacío.
  nullText?: string;
};

const MuiPhoneTextField = forwardRef<HTMLInputElement, any>(function MuiPhoneTextField(props, ref) {
  const { onChange, value, label, error, helperText, disabled, autoFocus, customWidth, description, ...rest } = props;
  return (
    <TextField
      {...rest}
      inputRef={ref}
      disabled={disabled}
      autoFocus={autoFocus}
      size="small"
      inputProps={{ autoComplete: "one-time-code" }}
      error={error}
      helperText={helperText}
      sx={{ m: 0, flex: 1 }}
      label={<FieldLabelWithHelp label={label} description={description} />}
      InputLabelProps={description ? { shrink: true } : undefined}
      value={value ?? ''}
      onChange={(e) => onChange?.(e)}
    />
  );
});

export const InputPhone: React.FC<InputPhoneProps> = ({
  label,
  value,
  onChange,
  helperText = "",
  error = false,
  autoFocus = false,
  customWidth = 500,
  disabled = false,
  hidden = false,
  description,
  nullText,
}) => {
  if (hidden) return null;

  // "(Opcional)" junto al label mientras no hay número. No es como InputString:
  // no se oculta con el foco, porque el "+54" que ponen international y
  // defaultCountry deja el label siempre arriba; se va con el primer dígito.
  const shownLabel = nullText && !value ? label + " (" + nullText + ")" : label;

  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', width: customWidth, margin: '8px' }}>
      <PhoneInput
        international
        defaultCountry="AR"
        value={(value || '') as E164Number}
        onChange={(val) => onChange(val || '')}
        disabled={disabled}
        inputComponent={MuiPhoneTextField}
        numberInputProps={{
          label: shownLabel,
          error,
          helperText,
          disabled,
          autoFocus,
          customWidth,
          description,
        }}
      />
    </div>
  );
};
